import { render } from "./RetirementManagement.vue?vue&type=template&id=815bb004&scoped=true"
import script from "./RetirementManagement.vue?vue&type=script&lang=js"
export * from "./RetirementManagement.vue?vue&type=script&lang=js"

import "./RetirementManagement.vue?vue&type=style&index=0&id=815bb004&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-815bb004"]])

export default __exports__